import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import styles from './AppShell.module.css';

const AppShell = ({ userInfo, userRole, setUserId, children }) => {
    const navigate = useNavigate();
    const isCoach = userRole === 1;

    const navItems = isCoach
        ? [
            { label: 'Overview', to: '/' },
            { label: 'Training Plans', to: '/training_plans' },
            { label: 'Trainings', to: '/trainings' },
            { label: 'Profile', to: '/profile' },
        ]
        : [
            { label: 'Overview', to: '/' },
            { label: 'Coaches', to: '/coaches' },
            { label: 'Training', to: '/trainings' },
            { label: 'Profile', to: '/profile' },
        ];

    const handleLogout = () => {
        document.cookie = 'authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        document.cookie = 'userId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        setUserId(null);
        navigate('/login');
    };

    return (
        <div className={styles.appFrame}>
            <aside className={styles.sidebar}>
                <div className={styles.brandBlock}>
                    <div className={styles.brand}>LtW</div>
                    <div className={styles.roleBadge}>{isCoach ? 'Coach workspace' : 'Your workspace'}</div>
                </div>

                <nav className={styles.nav}>
                    {navItems.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            end={item.to === '/'}
                            className={({ isActive }) =>
                                `${styles.navLink} ${isActive ? styles.navLinkActive : ''}`
                            }
                        >
                            {item.label}
                        </NavLink>
                    ))}
                </nav>

                <div className={styles.sidebarFooter}>
                    <div className={styles.userCard}>
                        <span className={styles.userLabel}>Signed in as</span>
                        <strong>{userInfo ? `${userInfo.firstName} ${userInfo.lastName}` : 'Loading...'}</strong>
                    </div>
                    <button className={styles.logoutButton} onClick={handleLogout} type="button">
                        Logout
                    </button>
                </div>
            </aside>

            <div className={styles.mainArea}>
                <div className={styles.topbar}>
                    <div>
                        <p className={styles.kicker}>Summary</p>
                        <h1>{isCoach ? 'Coach dashboard' : 'Your dashboard'}</h1>
                    </div>
                </div>
                <div className={styles.content}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default AppShell;
